module.exports = __webpack_public_path__ + "static/realign-db713f819db1d09a223c452a5769a299.png";